import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=7020cbf8&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=7020cbf8&prod&scoped=true&lang=scss"
import style1 from "./AboutUs.vue?vue&type=style&index=1&id=7020cbf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7020cbf8",
  null
  
)

export default component.exports